import { RefBool, RefString } from "@tblabs/truffle";


export class JsonValidator
{
    public IsValid = new RefBool();
    public Message = new RefString();

    constructor(json: RefString)
    {
        json.OnChange(v =>
        {
            try
            {
                JSON.parse(v);
                this.IsValid.value = true;
                this.Message.value = "✅ Valid";
            }
            catch (error)
            {
                console.error(error);
                this.IsValid.value = false;
                this.Message.value = "❌ Invalid json";
            }
        }, true);
    }
}
